import React from "react";

const Home = () => {
  return (
    <div className="home-container">
      <h1>Freezer Tips</h1>
      <p>
        <a
          href={
            "https://www.fourniresto.com/blog/tableau-duree-de-conservation-sous-vide/"
          }
          target="_blank"
          rel="noreferrer"
        >
          Durée de conservation des aliments sous vide
        </a>
      </p>
      <p>
        <a
          href={"https://cuisine-addict.com/guide-de-conservation-congelation/"}
          target="_blank"
          rel="noreferrer"
        >
          Durée de conservation des aliments congelés sous vide
        </a>
      </p>
      <p>
        <a
          href={
            "https://www.iceannuaire.net/2316-duree-de-conservation-des-noix-de-saint-jacques-congelees-tout-ce-quil-faut-savoir/"
          }
          target="_blank"
          rel="noreferrer"
        >
          Durée de conservation des Saint-Jacques
        </a>
      </p>
    </div>
  );
};

export default Home;
